/*
 * @Descripttion: your project
 * @version: 1.0
 * @Author: zouyuping
 * @Date: 2022-08-30 14:51:27
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-09-08 10:40:24
 */
import { requestOfPost, requestOfGet } from "../utils/http";
const baseUrl = "wechath5/zh-cn/v1/event";

// 获取领券中心活动详情
export function getGetCouponInfo(param) {
  return requestOfGet(`${baseUrl}/drawticket/${param.id}`, param);
}
export function takeCoupon(param) {
  return requestOfPost(`${baseUrl}/drawticket`, param);
}

// 团购分类列表
export function getGroupClassifyType(param) {
  return requestOfGet(`${baseUrl}/groupontypes/${param.id}`);
}
// 团购商品列表
export function getGroupGoodsList(param) {
  return requestOfGet(`${baseUrl}/grouponlist`, param);
}
export function getFlashRequestId() {
  return requestOfGet(`wechath5/get_request_id`);
}
export function submitFlashOrder(param) {
  return requestOfPost(`${baseUrl}/flash_sale/${param.VpnId}`, param);
}
export function secondSubmitFlashOrder(param) {
  return requestOfPost(`${baseUrl}/flash_sale/accept/${param.id}`, param);
}
export function getFlashOrderResult(param) {
  return requestOfPost(`${baseUrl}/flash_sale/fetch_result`, param);
}
